import React, { useState,useRef } from "react";
import { Accordion, Card, Container, ListGroup } from "react-bootstrap";
import "./styles.css";
import { Remarkable } from "remarkable";


function TrackCard({ res, eventKey }) {
  const md = useRef(new Remarkable({
    linkTarget: "_blank",
  }));

  return (
    <Container fluid>
      <Card border="info">
        <Accordion.Toggle
          as={Card.Header}
          border="info"
          className="d-flex justify-content-between bg-white border-info"
          eventKey={eventKey}
        >
          <span>{res.name}</span>
          <span className="text-muted" style={{ cursor: "pointer" }}>
            Click
          </span>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={eventKey}>
          <Card.Body>
            <ListGroup as="ul">
              {res.list && res.list.length > 0 ? (
                res.list.map((item, id) => (
                  <ListGroup.Item
                    className="d-flex justify-content-between"
                    as="li"
                    key={id}
                  >
                    <span>{item.name} </span>
                    <a
                      target="_blank"
                      href={item.link}
                      className="ml-4 text-truncate"
                    >
                      {item.link}
                    </a>
                  </ListGroup.Item>
                ))
              ) : (
                <div
                  className="output-text"
                  dangerouslySetInnerHTML={{ __html: md.current.render(res.msg) }}
                ></div>
              )}
            </ListGroup>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Container>
  );
}

export default TrackCard;
